var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forex-gpd-chart"},[_c('div',{staticClass:"box"},[_c('forex-gpd-chart',{attrs:{"apiCode":_vm.apiCode}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }